import { useCallback, useEffect } from 'react';
import type { FC } from 'react';

import { useTranslation } from 'react-i18next';

import {
  trackImpressionEvent,
  trackLoginClickEvent,
} from '../../services/tracking/pulseEvents';
import { login } from '../../services/schibstedAccount';
import type { ButtonProps } from '../Button/Button';
import { Button } from '../Button/Button';
import { pascalCaseToKebabCase } from '../../utils/string';
import { usePlayerAsset } from '../../player/hooks/usePlayerAsset';

interface LoginPaywallButtonProps {
  label?: string;
  size?: ButtonProps['size'];
}

const ELEMENT_TYPE = 'LoginPaywallButton';

const LoginPaywallButton: FC<LoginPaywallButtonProps> = ({
  label: labelProp,
  size = 'large',
}) => {
  const { t } = useTranslation();
  const asset = usePlayerAsset();

  let label = labelProp || t('Log in to watch')!;

  useEffect(() => {
    if (asset?.id) {
      trackImpressionEvent({
        id: pascalCaseToKebabCase(ELEMENT_TYPE),
        contentId: asset?.id.toString(),
        elementType: ELEMENT_TYPE,
        name: label,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [asset?.id]);

  const handleLoginClick = useCallback(() => {
    trackLoginClickEvent({
      button: {
        contentId: asset?.id.toString(),
        elementType: ELEMENT_TYPE,
        title: label,
      },
    });

    login('loginwall-splash');
  }, [asset?.id, label]);

  return (
    <Button
      size={size}
      variant="contained"
      active
      rounded
      onClick={handleLoginClick}
    >
      {label}
    </Button>
  );
};

export { LoginPaywallButton };
